import { useTranslation } from "react-i18next";
import { PersonalData } from "../../../../redux/apiSpecifications/apiSubjects";
import { FlexWrapper } from "../../../../style/FlexWrapper";
import { ButtonCancel, ButtonConfirm } from "../../../Layout/Buttons";
import SubjectPersonalDataForm, { validateSubjectPersonalDataForm } from "../Forms/SubjectPersonalDataForm";
import {
  useAddPolicySubjectContext,
  useAddPolicySubjectDispatch,
} from "./AddPolicySubjectContext";

interface IPersonalDataStepProps {
  onNextStep: () => void;
  onPreviousStep: () => void;
}

const PersonalDataStep = ({
  onNextStep,
  onPreviousStep,
}: IPersonalDataStepProps) => {
  const { t } = useTranslation();

  const dispatch = useAddPolicySubjectDispatch();

  const { addPolicySubjectData } = useAddPolicySubjectContext();

  const handleOnChange = (subjectPersonalData: PersonalData) => {
    dispatch!({
      type: "CHANGE_POLICY_SUBJECT_DATA",
      payload: {
        value: subjectPersonalData,
        field: "personalData",
      },
    });
  };

  const enableNextButton = validateSubjectPersonalDataForm(
    addPolicySubjectData?.personalData
  );

  return (
    <FlexWrapper flexDirection="column" gap="2em">
      <SubjectPersonalDataForm
        subjectPersonalData={addPolicySubjectData?.personalData!}
        onChange={handleOnChange}
      />

      <FlexWrapper gap="1em" justifyContent="flex-end">
        <ButtonCancel onClick={onPreviousStep}>
          {t("BUTTONS.previous")!}
        </ButtonCancel>

        <ButtonConfirm onClick={onNextStep} disabled={!enableNextButton}>
          {t("BUTTONS.next")!}
        </ButtonConfirm>
      </FlexWrapper>

      {/* <pre>{JSON.stringify(addPolicySubjectData, null, 2)}</pre> */}
    </FlexWrapper>
  );
};

export default PersonalDataStep;
